import React from 'react';
import NavBar from './NavBar';
import Grid from '@mui/material/Unstable_Grid2';
import {Amplify} from 'aws-amplify';
import { generateClient } from 'aws-amplify/api';
import TvShowContentCard from './TvShowContentCard';

export default function TvShows() {
        const [tvShows, setTvShows] = React.useState([]);

        React.useEffect(() => {
            fetchTvShows();
        }, []);
    
        const fetchTvShows = async () => {
            try {
                // const Secret_Val = process.env.REACT_APP_SECRECT_ACCESS_KEY;
                // const Secret_Val2 = process.env.REACT_APP_ACCESS_KEY;
                const Secret_Val = process.env.REACT_APP_API_KEY;
                const API_Endpoint = process.env.REACT_APP_API_ENDPOINT;

                Amplify.configure({
                    API: {
                        GraphQL: {
                            endpoint: API_Endpoint,
                            region: 'us-east-2',
                            defaultAuthMode: 'apiKey',
                            apiKey: Secret_Val
                        }
                    },
                });
                const client = generateClient();
                
                const listTvShows = `
                    query {
                        listTvShows {
                            items {
                                id
                                image_url
                                name
                                sortKey
                                tv_show_name
                                tv_show_season
                            }
                        }
                   }
                  `
                const tvShowData = await client.graphql({
                    query: listTvShows
                });
                const tvShowList = await tvShowData.data.listTvShows.items;
                
                const groupedTvShowList = tvShowList.reduce((acc, { name, image_url, tv_show_name, tv_show_season }) => {
                    let show = acc.find(s => s.tv_show_name === tv_show_name);

                    if (!show) {
                        show = { tv_show_name, image_url, content: {} };
                        acc.push(show);
                    }

                    if (!show.content[tv_show_season]) {
                        show.content[tv_show_season] = [];
                    }

                    show.content[tv_show_season].push(name);
                    return acc;

                }, []);

                setTvShows(groupedTvShowList);
    
            } catch (error) {
                console.log('error on fetching movies', error)
            }
        }

        return (
                <>
                    <NavBar />
                    <Grid container spacing={2} sx={{paddingLeft:'2%', paddingRight:'2%'}}>
                        {tvShows.map((tvShow) => {
                            return(
                                <TvShowContentCard
                                image={tvShow.image_url}
                                tvShowName={tvShow.tv_show_name}
                                content={tvShow.content}
                                />
                            )
                        })}
                    </Grid>
                </>
            );
};